<div class="card">
    <div class="card-body">
        <div class="card">
            <div class="card-body p-1">
                <div class="card">
                    <div class="text-center">
                        <div>
                            <i class="las la-info-circle fs-3hx text-danger"></i>
                        </div>
                        <h2>You don't have an organization to login. Please reach out to your administrator.</h2>
                        <p class="text-gray-800">Your access has been deactivated by the organization, resulting in your
                            removal from their
                            system. To restore access to EDA.education, simply sign up with a new email address and invite
                            yourself
                            to join the new organization as staff, using your existing email. This way, you can continue
                            using your current email within the new organization.</p>
                        <a href="javascript:void(0)" (click)="closeModel()"
                            class="btn btn-sm btn-light-danger er fs-6 px-8 py-4" data-bs-toggle="modal"
                            data-bs-target="#kt_modal_new_target">
                            Sign Out </a>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>